import React, { PureComponent } from 'react';
import styles from './ActiveDeliveryOtpCard.module.less';
import { Typography } from 'antd';
import { withTranslation } from 'react-i18next';
import * as PropTypes from 'prop-types';
import { formatDate } from '../../utils/dates';
import Paper from '../Paper/Paper';

class ActiveDeliveryOtpCard extends PureComponent {
  constructor(props) {
    super(props);
  }

  renderDropOff(dropoffDetails) {
    const { t } = this.props;
    if (!dropoffDetails) {
      return;
    }
    return (
      <div className={styles.location}>
        <div>
          <strong>{t('deliveryOtps.dropoffDetails')}</strong>
        </div>
        <div className={styles.blocked}>
          {dropoffDetails.building_name} - {dropoffDetails.street} - {dropoffDetails.area}
        </div>
      </div>
    );
  }

  render() {
    const { uuid, otp, expiresAt, pickupDetails, dropoffDetails, dateFormat, t } = this.props;
    return (
      <Paper data-testid="ActiveDeliveryOtpCard">
        <div className={styles.header}>
          <Typography.Text strong>
            {t('deliveryOtps.token')} #{otp}
          </Typography.Text>
        </div>
        <div className={styles.date}>
          <strong>{t('deliveryOtps.expiresAt')}: </strong>
          <span>{formatDate(expiresAt, dateFormat)}</span>
        </div>
        <div className={styles.location}>
          <div>
            <strong>{t('deliveryOtps.pickupDetails')}</strong>
          </div>
          <div className={styles.blocked}>
            {pickupDetails.building_name} - {pickupDetails.street} - {pickupDetails.area}
          </div>
        </div>
        {this.renderDropOff(dropoffDetails)}
        <div className={styles.otp}>
          <span>{uuid}</span>
        </div>
      </Paper>
    );
  }
}

ActiveDeliveryOtpCard.propTypes = {
  uuid: PropTypes.string.isRequired,
  otp: PropTypes.string.isRequired,
  expiresAt: PropTypes.instanceOf(Date),
  pickupDetails: PropTypes.object,
  dropoffDetails: PropTypes.object,
  t: PropTypes.func,
  dateFormat: PropTypes.string
};

ActiveDeliveryOtpCard.defaultProps = {
  dateFormat: 'd MMM yyyy, p'
};

export default withTranslation()(ActiveDeliveryOtpCard);
